import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import PageMenu from './PageMenu';
import {
  selectBracketMatches,
  selectUsesWc2026Bracket,
} from '@selectors/matches';
import {
  isSaving,
  isForecastDirty,
  canEditForecast,
  canActivateWildcardMode,
} from '@selectors/matches';
import { isShareForecast } from '@selectors/location';

// Corte para socios "nuevos": activación a partir del 28/06/2026 inclusive (UTC).
const NEW_MEMBER_CUTOFF_MS = Date.UTC(2026, 5, 28); // 2026-06-28T00:00:00Z

// Socio mensual nuevo: contributor + plan mensual + activado en/después del corte.
// Para estos se limita la funcionalidad de cambios (se les sigue ofreciendo el plan anual).
export const isNewMonthlyMember = (state) => {
  if (get(state, 'user.contributor') !== true) return false;
  if (get(state, 'user.plan_type') !== 'monthly') return false;
  const activation = get(state, 'user.activation_date');
  if (!activation) return false;
  const ts = new Date(activation).getTime();
  return Number.isFinite(ts) && ts >= NEW_MEMBER_CUTOFF_MS;
};

export const mapStateToProps = (state) => ({
  selected: state.subpage,
  shareMode: isShareForecast(state),
  canChangeForecast: !isEmpty(state.jwToken) && canEditForecast(state),
  enableSave: isForecastDirty(state),
  isSaving: isSaving(state),
  isContributor: get(state, 'user.contributor') === true,
  isNewMonthlyMember: isNewMonthlyMember(state),
  userEmail: get(state, 'user.email', ''),
  wildcardsAvailable: Math.max(0, Number(get(state, 'user.comodinesDisponibles', 0)) || 0),
  canActivateWildcardNow: canActivateWildcardMode(state),
});

export const mapDispatchToProps = (dispatch) => ({
  onChange: (type) => dispatch({ type: `SUBPAGE_${type.toUpperCase()}` }),
  onActivateWildcard: () =>
    dispatch((innerDispatch, getState) => {
      const faseActual = get(getState(), 'torneoEstado.faseActual');

      innerDispatch({
        type: 'WILDCARD_MODE_ENABLE',
        payload: { faseActivacion: faseActual },
      });

      const state = getState();
      const bracketMatches = Object.values(
        selectBracketMatches(state) || {}
      );

      innerDispatch({
        type: 'FORECAST_MATCHES_SYNC_BRACKET_FROM_RESULTS',
        payload: {
          matches: bracketMatches,
          faseActivacion: faseActual,
          hasRoundOf32: selectUsesWc2026Bracket(state),
        },
      });
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageMenu);
